import { basic, withUniqueClass } from "../../helpers/block-helpers";

export const magicContainerInput = basic.input({
    id: "magic-container",
    label: "Magic Container",
    description: "A magic container, use it to add any content to your page, adjust the width and height to fit your needs.",
    content: withUniqueClass(
        "div",
        (cls) =>
            `<div class="${cls}">
        <p>Your content goes here</p>
      </div>`
    ),
});